export default "/assets/images/home-wrecker1.4394cf26365cfe59.png";